import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ModelViewInventaire} from '../../inventaire/model-view-inventaire';
import {UtilsService} from '../../../../core/utils/utils.service';
import {ProduitArticleService} from '../../../../core/services/entities/produit-article.service';
import {StocksService} from '../../../../core/services/gestion-stock/stocks.service';
import {StockDTO} from '../../../../core/dtos/stock-dto';
import {InventaireFilters} from '../../../../core/models/gestion-stock/inventaire-filters.model';
import {DATEPICKER_FR, MSG_KEY, MSG_SEVERITY} from '../../../../core/constants';
import * as moment from 'moment';
import {StockMouvementStatutDTO} from '../../../../core/dtos/stock-mouvement-statut-dto';
import {StockMouvementDTO} from '../../../../core/dtos/stock-mouvement-dto';
import {StockMouvementStatutService} from '../../../../core/services/gestion-stock/stock-mouvement-statut.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {GenericFormService} from '../../../../core/services/generics/generic-form.service';
import {ToastService} from "../../../../core/services/technique/toast.service";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";

@Component({
    selector: 'yo-dialog-sortie',
    templateUrl: './dialog-sortie.component.html',
    styleUrls: ['./dialog-sortie.component.scss'],
    standalone: false
})
export class DialogSortieComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  subAction: Subscription;

  displayDialog = false;
  selectedStock: ModelViewInventaire;
  filters: InventaireFilters;
  matierePremiere: ModelViewInventaire;

  form: FormGroup;

  mouvementStatutList: StockMouvementStatutDTO[] = [];


  localeFr = DATEPICKER_FR;

  constructor(public utils: UtilsService,
              private produitArticleSvc: ProduitArticleService,
              public stockSvc: StocksService,
              private gfs: GenericFormService,
              public stockMvtStatutSvc: StockMouvementStatutService,
              private toastSvc: ToastService) {
  }

  initForm = (): void => {

    let max: number = 0;

    if (this.selectedStock && this.selectedStock.quantite) {
      max = this.selectedStock.quantite;
    }

    this.form = new FormGroup({
      quantite: new FormControl(0, [Validators.required, Validators.min(0.0001), Validators.max(max)]),
      dateSortie: new FormControl(new Date(), Validators.required),
      motif: new FormControl(undefined, Validators.required),
      remarque: new FormControl(undefined),
    });
  };

  ngOnInit(): void {

    this.initForm();

    this.subAction = this.stockSvc.openDialogSortie$.subscribe(response => {
      this.displayDialog = true;
      this.selectedStock = response.selectedStock;
      this.filters = response.filters;
      this.matierePremiere = response.matierePremiere;

      this.stockMvtStatutSvc.getAll(true, false)
        .subscribe(o => {
          console.log(o);
          this.mouvementStatutList = o.resultList;
        });

      this.initForm();

    });

  }

  closeDialog = () => {
    this.displayDialog = false;
  };

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subAction);
  }

  sortirLot = () => {


    this.gfs.validateAllFormFields(this.form);

    if (this.form.valid) {

      const dateSortie = this.form.controls['dateSortie'].value;
      const remarque = this.form.controls['remarque'].value;
      const quantite = this.form.controls['quantite'].value;
      const motif = this.form.controls['motif'].value;

      if (moment(this.selectedStock.dateEntree).isSameOrBefore(moment(dateSortie), 'day')) {
        const stockMouvement = new StockMouvementDTO(dateSortie, remarque, quantite, 0, this.selectedStock.id, motif.code, motif.id, dateSortie);
        const stockToRelease = { id: this.selectedStock.id, moves: [stockMouvement] } as StockDTO;
        this.stockMvtStatutSvc.saveSortie(stockToRelease).subscribe(response => {
          if (response) {
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `La sortie a été enregistrée avec succès`);
            this.stockSvc.announceRefreshStocks(this.selectedStock.parent);
            this.closeDialog();
          }
        });
      } else {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `La date de sortie ne peut pas être antérieure à la date d'entrée`);
      }
    }
  };

  onMotifSelectionChanged = (e: { addedItems?: StockMouvementStatutDTO[] }): void => {
    const selected = e.addedItems?.[0];
    this.form.controls['motif'].setValue(selected ?? null);
    this.form.controls['motif'].markAsTouched();
  };

  startError = (property: string) => `Le champ "${property.toUpperCase()}" `;
}
